var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookingActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 58,
    viewBox: "0 0 56 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1123_138884)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 44,
    height: 44,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint0_linear_1123_138884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 44,
    height: 44,
    rx: 8,
    fill: "url(#paint1_linear_1123_138884)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 2.5,
    width: 43,
    height: 43,
    rx: 7.5,
    stroke: "url(#paint2_linear_1123_138884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1002 14.9003C36.8211 14.6176 36.4887 14.3931 36.1222 14.2399C35.7557 14.0867 35.3624 14.0078 34.9652 14.0078C34.5679 14.0078 34.1746 14.0867 33.8081 14.2399C33.4416 14.3931 33.1092 14.6176 32.8302 14.9003L30.9102 16.8503L35.1502 21.0903L37.0702 19.1703C37.3548 18.8932 37.5816 18.5623 37.7374 18.1969C37.8932 17.8315 37.9748 17.4388 37.9776 17.0415C37.9804 16.6443 37.9043 16.2505 37.7537 15.8829C37.603 15.5153 37.3809 15.1813 37.1002 14.9003Z",
    fill: "url(#paint3_linear_1123_138884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4901 18.2695L21.1001 26.6595C21.0249 26.7369 20.9609 26.8244 20.9101 26.9195L18.1301 32.5295C18.0494 32.681 18.0091 32.8506 18.0129 33.0221C18.0168 33.1936 18.0647 33.3613 18.1521 33.5089C18.2395 33.6566 18.3634 33.7793 18.5119 33.8652C18.6604 33.9511 18.8285 33.9974 19.0001 33.9995C19.1524 34.0002 19.3029 33.966 19.4401 33.8995L25.0501 31.1195C25.1452 31.0687 25.2327 31.0047 25.3101 30.9295L33.7001 22.5395L29.4901 18.2695Z",
    fill: "url(#paint4_linear_1123_138884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37 34H28C27.7348 34 27.4804 33.8946 27.2929 33.7071C27.1054 33.5196 27 33.2652 27 33C27 32.7348 27.1054 32.4804 27.2929 32.2929C27.4804 32.1054 27.7348 32 28 32H37C37.2652 32 37.5196 32.1054 37.7071 32.2929C37.8946 32.4804 38 32.7348 38 33C38 33.2652 37.8946 33.5196 37.7071 33.7071C37.5196 33.8946 37.2652 34 37 34Z",
    fill: "url(#paint5_linear_1123_138884)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1123_138884",
    x: 0,
    y: 0,
    width: 56,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0 0.275 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1123_138884"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0 0.27451 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1123_138884",
    result: "effect2_dropShadow_1123_138884"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1123_138884",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1123_138884",
    x1: 1.98955,
    y1: -17.2312,
    x2: 22.1023,
    y2: 16.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1123_138884",
    x1: 36.8993,
    y1: 39.4189,
    x2: 56.9344,
    y2: 65.8203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1123_138884",
    x1: 2.14737,
    y1: -17.3294,
    x2: 28,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1123_138884",
    x1: 30.9057,
    y1: 21.7988,
    x2: 34.7976,
    y2: 12.6777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970034,
    stopColor: "#2C3CA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1123_138884",
    x1: 18.0027,
    y1: 35.5732,
    x2: 26.6502,
    y2: 15.3191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970034,
    stopColor: "#2C3CA9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1123_138884",
    x1: 26.993,
    y1: 34.2001,
    x2: 27.2273,
    y2: 31.1736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B89DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.970034,
    stopColor: "#2C3CA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingActive);
export default __webpack_public_path__ + "static/media/booking_active.70b39fc810b315342f435f89a806a9a1.svg";
export { ForwardRef as ReactComponent };